export function getMaxValue(value: number): number {
  // does not work with exponential number cast
  return parseInt('9'.repeat(Math.trunc(value).toString().length), 10);
}
